import React, { useEffect, useState } from 'react';
import { ArrowLeft, Loader2, Save } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import useAccountStore from '../../store/useAccountStore';
import Breadcrumb from '../../components/common/Breadcrumb';
import PersonnelFormFields from '../../components/personnel/PersonnelFormFields';

const emptyForm = {
  name: '',
  code: '',
  type: 'EMPLOYEE',
  employmentType: 'FIXED',
  personnelGroup: null,
  dailyRate: 0,
  currency: 'TRY',
  phone: '',
  email: '',
  status: 'Active',
  notes: ''
};

const normalizePersonnelFormData = (personnel = {}) => ({
  ...emptyForm,
  ...personnel,
  type: 'EMPLOYEE',
  employmentType: personnel.employmentType || 'FIXED'
});

const PersonnelCreate = () => {
  const navigate = useNavigate();
  const { saveAccount, getNextCode } = useAccountStore();
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      const nextCode = await getNextCode('EMPLOYEE');
      if (!mounted) return;

      setFormData({
        ...emptyForm,
        code: nextCode
      });
    };

    init();

    return () => {
      mounted = false;
    };
  }, [getNextCode]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);

    const result = await saveAccount({
      ...normalizePersonnelFormData(formData),
      type: 'EMPLOYEE'
    });

    setSaving(false);

    if (result.success) {
      toast.success('Personel eklendi');
      navigate('/personnel');
      return;
    }

    toast.error(result.message || 'Personel kaydedilemedi');
  };

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      <Breadcrumb
        items={[
          { label: 'Personel Listesi', href: '/personnel' },
          { label: 'Yeni Personel Ekle' }
        ]}
      />

      <div className="flex flex-col gap-4 rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm md:flex-row md:items-center md:justify-between">
        <div>
          <button
            type="button"
            onClick={() => navigate('/personnel')}
            className="mb-3 inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-xs font-black uppercase tracking-widest text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-800"
          >
            <ArrowLeft size={14} />
            Listeye Dön
          </button>
          <h1 className="text-2xl font-black text-slate-800 tracking-tight">Yeni Personel Oluştur</h1>
          <p className="text-sm text-slate-500">Personel bilgilerini tek sayfada kaydedin.</p>
        </div>
        <div className="rounded-2xl bg-slate-50 px-4 py-3 text-xs font-black uppercase tracking-widest text-slate-500">
          Personel carisi
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <PersonnelFormFields
          formData={formData}
          setFormData={setFormData}
          showStatus
          showNotes
          showCode
        />

        <div className="flex flex-col gap-3 rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => navigate('/personnel')}
            className="rounded-2xl bg-slate-100 px-5 py-3 text-xs font-black uppercase tracking-widest text-slate-600 transition-colors hover:bg-slate-200"
          >
            İptal
          </button>
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 px-5 py-3 text-xs font-black uppercase tracking-widest text-white transition-colors hover:bg-black disabled:cursor-not-allowed disabled:opacity-60"
          >
            {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}
            Kaydet
          </button>
        </div>
      </form>
    </div>
  );
};

export default PersonnelCreate;
